/* eslint-disable fp/no-mutating-methods */
/* eslint-disable fp/no-loops */

import { VideoLinks } from '~/redux/apis/user-stats-api'

import { ProgressBarData } from '../types/product-card.types'

export function getVideoProgressData(
  videoWatched: number,
  totalVideo: number,
  videoLinks?: VideoLinks[],
): ProgressBarData[] {
  const data: ProgressBarData[] = []

  if (videoLinks?.length) {
    videoLinks.forEach((video) => {
      data.push({ value: 1, color: video.isWatched ? '#7D38D6' : '#AFAFAF', videoLink: video.path })
    })
  } else {
    for (let i = 0; i < videoWatched; i++) {
      data.push({ value: 1, color: '#7D38D6' })
    }

    const videoNotWatched = totalVideo - videoWatched

    for (let i = 0; i < videoNotWatched; i++) {
      data.push({ value: 1, color: '#AFAFAF' })
    }
  }

  return data
}
